<div class="suggested-prompts" *ngIf="prompts && prompts.length > 0">
    <div class="prompts-container">
        <button *ngFor="let prompt of prompts; trackBy: trackByText" class="form-control fs14 fw-400" (click)="selectPrompt(prompt)"
            [title]="prompt.text">
            <span class="prompt-icon" *ngIf="prompt.icon">{{ prompt.icon }}</span>
            <span class="prompt-text">{{ prompt.text }}</span>
        </button>
    </div>
</div>
